import React, { Component } from 'react';
import Joyride from "react-joyride";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import steps from "./steps/steps";
import { changeStep } from "./actions.js";

class Tour extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.scrollToSteps) {
      ReactDOM.findDOMNode(this.joyride).setAttribute("style", "display: block;")
    } else {
      ReactDOM.findDOMNode(this.joyride).setAttribute("style", "display: none;");
    }
  }

  callback = (object) => {
    if (object.type === "step:before") {
      this.props.changeStep(object.index);
      this.props.startProgress();
    }

    if (object.action === "back" && object.index === 0) {
      this.props.changeStep(0);
    }

    if(object.type === "finished") {
      this.props.closeTour();
      this.props.changeStep(0);
      this.props.stopProgress();
      this.joyride.reset(false);
    }

    if (object.action === 'close' && object.type === 'step:after') {
      this.props.closeTour();
    }
  }

  render() {
    return (
      <div>
        <Joyride
          ref={c => this.joyride = c}
          steps={steps}
          stepIndex={this.props.step}
          run={this.props.shouldShowTour}
          autoStart={true}
          type="continuous"
          showSkipButton={true}
          showStepsProgress={true}
          scrollToSteps={this.props.scrollToSteps}
          callback={this.callback}
          keyboardNavigation={false}
          debug={false}
          locale={{ back: 'Back', close: 'Close', last: 'Close', next: 'Next', skip: 'Skip' }}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    blockchain: state.blockchain,
    step: state.step
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeStep: (number) => {
      dispatch(changeStep(number));
    }
  };
}

const TourContainer = connect(mapStateToProps, mapDispatchToProps)(Tour)

export default TourContainer;


// WEBPACK FOOTER //
// ./src/Tour.js